// src/index.ts
import { SignJWT, jwtVerify, decodeJwt, errors as joseErrors } from "jose";
async function signGameToken(payload, secret, expiresIn = "30d") {
  const key = new TextEncoder().encode(secret);
  return new SignJWT({ ...payload }).setProtectedHeader({ alg: "HS256" }).setIssuedAt().setExpirationTime(expiresIn).sign(key);
}
async function verifyGameToken(token, secret, opts) {
  const key = new TextEncoder().encode(secret);
  try {
    const { payload } = await jwtVerify(token, key);
    return payload;
  } catch (err) {
    if (opts?.ignoreExpiration && err instanceof joseErrors.JWTExpired) {
      return decodeJwt(token);
    }
    throw err;
  }
}
function decodeGameToken(token) {
  return decodeJwt(token);
}
async function signSessionToken(payload, secret) {
  const key = new TextEncoder().encode(secret);
  return new SignJWT({ ...payload }).setProtectedHeader({ alg: "HS256" }).setIssuedAt().setExpirationTime("7d").sign(key);
}
async function verifySessionToken(token, secret) {
  const key = new TextEncoder().encode(secret);
  const { payload } = await jwtVerify(token, key);
  return payload;
}
export {
  decodeGameToken,
  signGameToken,
  signSessionToken,
  verifyGameToken,
  verifySessionToken
};
